import { ID } from './common';

export const RolUsuario = {
  admin: 'admin',
  moderator: 'moderator',
  user: 'user',
  mostrador: 'mostrador',
} as const;
export type RolUsuario = typeof RolUsuario[keyof typeof RolUsuario];

export interface Usuario {
  id: ID;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  full_name?: string;
  role: RolUsuario;
  is_active: boolean;
  last_login?: string | null;
  created_at?: string;
  updated_at?: string;
}

